module.exports = "https://cdn-shared.mathletics.com/teacher-modules/curriculum-manager/15assets/fonts/674f50d287a8c48dc19ba404d20fe713.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0
// module id = 244
// module chunks = 4